import {useQuery} from "@tanstack/react-query";
import {analyzeListMapInit} from "../state";
import {AnalyzeSearchParamType} from "../interface";
import {readInventoryAnalysis} from "../../../../../api/inventory/AnalyzeApi";

type Props = {
    param: AnalyzeSearchParamType;
};

export const useReadInventoryAnalysis = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readInventoryAnalysis", param],
        queryFn: async () => await readInventoryAnalysis(param),
        select: (res) => res?.data.result ?? analyzeListMapInit,
    });

    return {data};
};
